import pl from "@locales/integrations/pl.json";
import en from "@locales/integrations/en.json";

export default {
  pl: pl,
  en: en,
};
